import { render, staticRenderFns } from "./successMassege.vue?vue&type=template&id=364486a8"
import script from "./successMassege.vue?vue&type=script&lang=js"
export * from "./successMassege.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports